<script>
import RawData from "@/components/widgets/raw-data.vue";
import { groupBy } from "lodash";
export default {
  components: {
    RawData,
  },
  props: {
    items: {},
    accounts: {},
    api: {},
    record: {},
    tableBusy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      realignmentItems: [],
      realignmentAccounts: [],
      selectedReason: "",
      reasons: [
        {
          id: 1,
          reason:
            "Unforseen modification of adjustments in the Activity/Program/Initiative (API):",
        },
        {
          id: 2,
          reason:
            "Re-assessment in the use. Prioritization and/or distribution of resources:",
        },
        {
          id: 3,
          reason:
            "Additional requirements for an API in view of a declaration of a state of calamity:",
        },
      ],
    };
  },
  watch: {
    items() {
      this.realignmentItems = this.items;
    },
    accounts() {
      this.realignmentAccounts = this.accounts;
    },
  },
  methods: {
    calculateTotal(items) {
      let total = 0;
      for (const key in items) {
        if (items.hasOwnProperty(key)) {
          if (key !== "fundSource") {
            const arr = items[key];
            for (let i = 0; i < arr.length; i++) {
              total += arr[i].total;
            }
          }
        }
      }
      return total;
    },
    calculatePerQuarter(data, quarter) {
      /** calculate total per quarter */
      let total = 0;
      if (data[quarter]) {
        for (let i = 0; i < data[quarter].length; i++) {
          total += data[quarter][i].total;
        }
      }
      return total;
    },
    calculateSubTotalPerQuerter(data, quarter) {
      /** calculate subtotal per quarter */
      let total = 0;
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const arr = data[key];
          if (arr[quarter]) {
            for (let i = 0; i < arr[quarter].length; i++) {
              total += arr[quarter][i].total;
            }
          }
        }
      }

      return total > 0 ? this.formatCurrency(total) : "-";
    },
    calculateGrandSubtotal(data) {
      /** calculate grand total */
      let total = 0;
      // for (const key in data) {
        data.items.map((item) => {
          total += item.total;
        });
      // }
      return total > 0 ? this.formatCurrency(total) : "-";
    },
    calculateTotalPerQuarter(data, quarter) {
      /** calculate subtotal per quarter */
      let total = 0;
      if(quarter == 1){
        data.map((item) => {
          total += item.q1;
        });
      } else if(quarter == 2){
        data.map((item) => {
          total += item.q2;
        });
      } else if(quarter == 3){
        data.map((item) => {
          total += item.q3;
        });
      } else if(quarter == 4){
        data.map((item) => {
          total += item.q4;
        });
      }
      return total > 0 ? this.formatCurrency(total) : "-";
    },
    calculateGrandTotal(data) {
      let total = 0;
      data.map((item) => {
        total += item.total;
      });
      return total > 0 ? this.formatCurrency(total) : "-";
    },
    calculateAccountsPerQuarter(data, quarter) {
      let total = 0;
      for (let i = 0; i < data.length; i++) {
        total += data[i][quarter];
      }
      return total > 0 ? this.formatCurrency(total) : "-";
    },
    calculateAccountGrandTotal(data) {
      let total = 0;
      for (let i = 0; i < data.length; i++) {
        total += data[i].total;
      }
      return total > 0 ? this.formatCurrency(total) : "-";
    },
    viewItems(items) {
      items.map((item) => {
        item.filterKey = `${item.apiResource.itemName}`;
      });
      this.$emit("view-items", items);
    },
  },
  computed: {
    rows() {
      let data = this.items;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.filterKey
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      return data.length;
    },
  },
  created() {},
};
</script>

<template>
  <div class="border p-3 rounded">
    <h5 class="text-pink">Part 1: Reason of Modification of Budget</h5>
    <p class="mb-0">
      <span class="text-info">Reason: </span>
      <span class="text-light">{{
        reasons.find((reason) => reason.id === record.reason).reason
      }}</span>
    </p>
    <p class="mb-0">
      <span class="text-info">Explanation: </span>
      <span class="text-light">{{ record.note }}</span>
    </p>
    <hr class="mt-2 mb-3 text-warning" />
    <h5 class="text-pink">Part 2: Approved Line Item Budget to be Modified</h5>
    <!-- <p class="mb-0">
      <span class="text-info">Goal: </span><span class="text-light">{{ api.goal }}</span>
    </p>
    <p class="mb-0">
      <span class="text-info">PREXC: </span><span class="text-light">{{ api.prexc }}</span>
    </p>
    <p>
      <span class="text-info">Activity: </span><span class="text-light">{{ api.name }}</span>
    </p> -->
    <div class="table-responsive mb-2">
      <table class="table table-bordered mb-0 broken-border border-primary">
        <thead class="table-light text-light">
          <tr>
            <th rowspan="2" scope="col" class="align-middle text-center">
              Item of Expenditures
            </th>
            <th colspan="5" scope="col" class="align-middle text-center">
              Amount
            </th>
          </tr>
          <tr>
            <th class="text-center" scope="col" width="150px">1st Qtr</th>
            <th class="text-center" scope="col" width="150px">2nd Qtr</th>
            <th class="text-center" scope="col" width="150px">3rd Qtr</th>
            <th class="text-center" scope="col" width="150px">4th Qtr</th>
            <th class="text-end" scope="col" width="150px">Total</th>
          </tr>
        </thead>

        <tbody
          v-for="api in realignmentItems"
          :key="api.apiId"
          style="border-bottom: 50px"
        >
          <tr>
            <td class="text-light" colspan="100%">
              <strong style="white-space: normal">{{ api.api }}</strong>
            </td>
          </tr>
          <tr v-for="acc in api.accounts" :key="acc.groupId">
            <td class="position-relative">
              <RawData :data="acc" v-if="$store.state.decrypt.isAdmin()" />
              <span class="d-block text-light">{{ acc.account }}</span>
              <small class="badge bg-success">{{ acc.fundSource }}</small>
              <div>
                <a
                  href="javascript:void(0);"
                  @click="viewItems(acc.items)"
                  class="hover-underlined d-flex align-items-center"
                  >View Items <i class="bx bx-chevron-right"></i
                ></a>
              </div>
            </td>
            <td class="text-end text-yellow">
              {{
                acc.totalQ1 == 0
                  ? "-"
                  : formatCurrency(acc.totalQ1)
              }}
            </td>
            <td class="text-end text-yellow">
              {{
                acc.totalQ2 == 0
                  ? "-"
                  : formatCurrency(acc.totalQ2)
              }}
            </td>
            <td class="text-end text-yellow">
              {{
                acc.totalQ3 == 0
                  ? "-"
                  : formatCurrency(acc.totalQ3)
              }}
            </td>
            <td class="text-end text-yellow">
              {{
                acc.totalQ4 == 0
                  ? "-"
                  : formatCurrency(acc.totalQ4)
              }}
            </td>
            <td class="text-end text-yellow">
              {{
                formatCurrency(
                  acc.total
                )
              }}
            </td>
          </tr>
          <tr>
            <td class="text-light"><strong>API Subtotal</strong></td>
            <td class="text-end text-yellow">
              {{ api.q1 == 0 ? '-' : formatCurrency(api.q1) }}
            </td>
            <td class="text-end text-yellow">
              {{ api.q2 == 0 ? '-' : formatCurrency(api.q2) }}
            </td>
            <td class="text-end text-yellow">
              {{ api.q3 == 0 ? '-' : formatCurrency(api.q3)}}
            </td>
            <td class="text-end text-yellow">
              {{ api.q4 == 0 ? '-' : formatCurrency(api.q4)}}
            </td>
            <td class="text-end text-yellow">
              <strong>{{ formatCurrency(api.total) }}</strong>
            </td>
          </tr>
        </tbody>

      <tbody>
        <tr>
          <td class="text-light"><strong>Total</strong></td>
          <td class="text-end text-yellow">
            {{ calculateTotalPerQuarter(realignmentItems, 1) }}
          </td>
          <td class="text-end text-yellow">
            {{ calculateTotalPerQuarter(realignmentItems, 2) }}
          </td>
          <td class="text-end text-yellow">
            {{ calculateTotalPerQuarter(realignmentItems, 3) }}
          </td>
          <td class="text-end text-yellow">
            {{ calculateTotalPerQuarter(realignmentItems, 4) }}
          </td>
          <td class="text-end text-yellow">
            <strong>{{ calculateGrandTotal(realignmentItems) }}</strong>
          </td>
        </tr>
      </tbody>
      </table>
    </div>
    <hr class="mt-2 mb-3 text-warning" />
    <h5 class="text-pink">Part 3: Proposed Modification</h5>
    <!-- <p class="mb-0">
      <span class="text-info">Goal: </span><span class="text-light">{{ api.goal }}</span>
    </p>
    <p class="mb-0">
      <span class="text-info">PREXC: </span><span class="text-light">{{ api.prexc }}</span>
    </p> -->
    <p>
      <span class="text-info">Activity: </span
      ><span class="text-light">{{
        record.newApiName ? record.newApiName : "Not Indicated"
      }}</span>
    </p>
    <div class="table-responsive mb-2">
      <table class="table table-bordered mb-0 broken-border border-primary">
        <thead class="table-light text-light">
          <tr>
            <th rowspan="2" scope="col" class="align-middle text-center">
              Item of Expenditures
            </th>
            <th colspan="5" scope="col" class="align-middle text-center">
              Amount
            </th>
          </tr>
          <tr>
            <th class="text-center" scope="col" width="150px">1st Qtr</th>
            <th class="text-center" scope="col" width="150px">2nd Qtr</th>
            <th class="text-center" scope="col" width="150px">3rd Qtr</th>
            <th class="text-center" scope="col" width="150px">4th Qtr</th>
            <th class="text-end" scope="col" width="150px">Total</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="account in realignmentAccounts" :key="account.id">
            <td class="text-light position-relative">
              <RawData :data="account" v-if="$store.state.decrypt.isAdmin()" />
              {{ account.accountGroup }}
              <!-- <span class="text-green">({{ account.account.accountGroup.groupName }})</span> -->
            </td>
            <td class="text-end text-yellow">
              {{ account.q1 === 0 ? "-" : formatCurrency(account.q1) }}
            </td>
            <td class="text-end text-yellow">
              {{ account.q2 === 0 ? "-" : formatCurrency(account.q2) }}
            </td>
            <td class="text-end text-yellow">
              {{ account.q3 === 0 ? "-" : formatCurrency(account.q3) }}
            </td>
            <td class="text-end text-yellow">
              {{ account.q4 === 0 ? "-" : formatCurrency(account.q4) }}
            </td>
            <td class="text-end text-yellow">
              {{ formatCurrency(account.total) }}
            </td>
          </tr>
          <tr>
            <td class="text-light"><strong>Total</strong></td>
            <td class="text-end text-yellow">
              {{ calculateAccountsPerQuarter(realignmentAccounts, "q1") }}
            </td>
            <td class="text-end text-yellow">
              {{ calculateAccountsPerQuarter(realignmentAccounts, "q2") }}
            </td>
            <td class="text-end text-yellow">
              {{ calculateAccountsPerQuarter(realignmentAccounts, "q3") }}
            </td>
            <td class="text-end text-yellow">
              {{ calculateAccountsPerQuarter(realignmentAccounts, "q4") }}
            </td>
            <td class="text-end text-yellow">
              <strong>{{
                calculateAccountGrandTotal(realignmentAccounts)
              }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
